// ExpiryChip.jsx — shows time remaining before a folder share expires.
// Colors (ZUI graphic tokens):
//   < 1 hour → --zui-color-graphic-red    (urgent, counts down in minutes)
//   < 1 day  → --zui-color-graphic-red    (urgent, counts down in hours)
//   1–5 days → --zui-color-graphic-yellow (warning)
//   > 5 days → --zui-color-graphic-green  (safe)
import React from 'react';
import './ExpiryChip.scss';

function formatExpiry(expiresAt) {
  const diffMs = new Date(expiresAt).getTime() - Date.now();
  if (diffMs <= 0) return { label: '0m', tier: 'red' };

  const totalMinutes = Math.floor(diffMs / (1000 * 60));
  const totalHours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;

  if (totalHours === 0) return { label: `${minutes}m`, tier: 'red' };
  if (days === 0) return { label: `${totalHours}h`, tier: 'red' };
  if (days <= 5) return { label: hours > 0 ? `${days}d ${hours}h` : `${days}d`, tier: 'amber' };
  return { label: `${days}d`, tier: 'green' };
}

export function ExpiryChip({ expiresAt }) {
  if (!expiresAt) return null;

  const { label, tier } = formatExpiry(expiresAt);

  return <span className={`expiry-chip expiry-chip--${tier}`}>{label}</span>;
}
